// extracted by mini-css-extract-plugin
module.exports = {"title":"ItemAttribute_title__hPID2","iconWrapper":"ItemAttribute_iconWrapper__CnoEN"};